<template>
  <div class="card">
    <div class="card-header">
      <div>
        <h5 class="d-inline-block mb-3">
          {{ $t('Email Notification Setup') }}
        </h5>
        <b-button class="float-right p-0" variant="link" v-permission="'change_customer'"
                  @click="editTemplatesToCustomer()">
          <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
          {{ $t('Edit') }}
        </b-button>
      </div>
      <div class="row border-top pt-2">
        <div class="col-md-5 font-weight-bold"> {{ $t('Templates') }}
        </div>
        <div class="col col-md-7 font-weight-bold">{{ $t('Emails') }}</div>
      </div>
    </div>
    <spinner :show="loading"/>
    <div v-if="!loading" class="card-body scroll">
      <div class="table mb-0 table-sm" v-if="templatesToEmailsTableData && templatesToEmailsTableData.length !== 0">
        <div v-for="(item, index) in templatesToEmailsTableData" :key="`tier-${index}`" class="row">
          <div class="col col-md-5 border-top border-right py-2 pl-3" :class="{'border-top-0': index===0}">
            {{ templateNamesMap[item.template_type] }}
          </div>
          <div class="col col-md-7 pl-0 border-top" :class="{'border-top-0': index===0}">
            <ul class="pl-4 pr-2 pt-2">
              <li v-for="email in item.emails">{{ email }}</li>
            </ul>
          </div>
        </div>
      </div>
      <no-data-available v-if="!templatesToEmailsTableData || templatesToEmailsTableData.length === 0" height="10"/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import Spinner from "../../../../core/components/common/Spinner";
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');
  export default {
    name: "EmailNotificationSetup.vue",
    components: {Spinner, NoDataAvailable},
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        templatesToEmailsTableData: state => state.templatesToEmailsTableData,
      }),
      ...globalMapState({
        templateNamesMap: state => {
          let namesMap = {}
          state.template_types.forEach(temp => namesMap[temp.key] = temp.display_name)
          return namesMap;
        }
      }),
    },
    methods: {
      ...mapActions(['showTemplatesToEmailsModal']),
      editTemplatesToCustomer() {
        this.showTemplatesToEmailsModal({items: this.templatesToEmailsTableData})
      }
    }
  }
</script>

<style scoped>
  .scroll {
    max-height: 500px;
    overflow-y: auto;
    overflow-x: clip;
  }
</style>